import ArchiveIssue from "@/src/_types/archive-issue";
import Journal from "@/src/_types/journal";
// import { getPostCountByPostIssueId } from "@/src/utils/database-helpers/post-helper";
import {getIssueLink, getXmlIssueDownloadLink} from "@/src/utils/journal-directory-helper";
import moment from "moment";
import Archive from "@/src/_types/Archive/archive";

export const MapToArchiveItems = (data: any): Archive[] => {
    return data?.map((issue: Archive) => ({
        id: issue.id,
        volume_id: issue.volume_id,
        volume_name: issue.volume_name,
        formatted_publish_date: issue.formatted_publish_date ?? issue.publish_date,
        published_date: issue.published_date,
        name: issue.name,
        articlesCount: issue.articlesCount
    }));
}

export const MapToArchiveIssueItems = (data: {
    journal: Journal;
    archives: Archive[];
}): ArchiveIssue[] => {
    const archiveIssues: ArchiveIssue[] = [];
    for (const issue of data.archives) {
        const xmlDownloadLink =
            data.journal.services?.issue_isc_xml?.status
                ? getXmlIssueDownloadLink(data.journal, issue.id)
                : null;

        archiveIssues.push({
            id: issue.id,
            volume_id: issue.volume_id,
            name: issue.name,
            formatted_publish_date: moment(issue.formatted_publish_date).format("MMM YYYY") ?? moment(issue.publish_date).format("MMM YYYY"),
            published_date: moment(issue.published_date).format("MMM YYYY"),
            articlesCount: issue.articlesCount,
            xml_link: xmlDownloadLink,
            issue_link: getIssueLink(data.journal, issue.id) || null,
        });
    }

    return archiveIssues;
};
